import type { MFAttestationSummary } from "state/members/accessReviews";
import { isOwnerSignOff } from "./signOff";

type WithEvidenceFields = Pick<MFAttestationSummary, "reviewType"> &
  Partial<Pick<MFAttestationSummary, "status" | "accessReviewId">>;

export const EVIDENCE_KICKER = "Evidence (optional)";

export const EVIDENCE_BODY =
  "Attach an export or screenshot from the system if you have one. It is stored with the review and shown on the certificate.";

/**
 * Evidence is offered on owner sign-off attestations only, and only when we
 * know which review to attach it to. Standard attestations keep evidence on
 * the review page itself.
 */
export const showsEvidencePanel = (att: WithEvidenceFields): boolean =>
  isOwnerSignOff(att) && !!att.accessReviewId;

/**
 * The server accepts uploads from the active attester until they attest, so
 * the panel is editable while the attestation is still pending.
 */
export const evidenceEditable = (att: WithEvidenceFields): boolean =>
  showsEvidencePanel(att) && att.status === "pending";
